import { ReactNode } from "react";
import FormFieldWrapper, {
  FormFieldWrapperProps,
} from "components/Shared/Forms/FormFieldWrapper";
import SwitchInput from "components/Shared/Forms/SwitchInput";

const LABEL_SIZE_MAP: Record<string, string> = {
  xs: "xs",
  sm: "xs",
  md: "sm",
  lg: "md",
  xl: "lg",
};

export type LabeledToggleProps = FormFieldWrapperProps & {
  isOn: boolean;
  label: ReactNode;
  onIsOnChange: (value: boolean) => void;
};

export default function LabeledToggle({
  isOn,
  onIsOnChange,
  size = "sm",
  ...rest
}: LabeledToggleProps) {
  return (
    <FormFieldWrapper
      display="flex"
      alignItems="baseline"
      my={0}
      gap={2}
      {...rest}
      labelProps={{
        fontSize:
          (typeof size === "string" && LABEL_SIZE_MAP[size]) || undefined,
        m: 0,
        color: "gray.600",
        ...rest.labelProps,
      }}
    >
      <SwitchInput value={isOn} onChange={onIsOnChange} size={size} />
    </FormFieldWrapper>
  );
}
